import { Stack } from 'braid-design-system';

import { FaqAccordion } from 'src/components/FaqAccordion/FaqAccordion';

import { BrandBanner } from './BrandBanner';
import { CustomerStatement } from './CustomerStatement';
import { faqs } from './FaqContent';
import { PackagesContainer } from './Packages';
import { StepByStepInfo } from './StepByStepInfo';
import { SupportMessage } from './SupportMessage';

export const PackagesPageSections = () => (
  <Stack space="xxlarge">
    <PackagesContainer />

    <FaqAccordion faqs={faqs} />

    <StepByStepInfo />

    <SupportMessage />

    <CustomerStatement />

    <BrandBanner />
  </Stack>
);
